import { Component } from 'react';
import { connect } from 'react-redux';
import { ChromePicker } from 'react-color';
import { asField } from 'informed';
import { Icon } from 'components/common/icons';
import { TextInput } from 'components/common/form/common';

const ColorPicker = connect((state) => state)(
  asField(
    class extends Component {
      state = {
        pickerVisible: false
      };

      componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
      }

      rgbObjectToString = (rgb) => {
        return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, ${rgb.a})`;
      };

      rgbStringToObject = (rgb) => {
        const values = rgb
          .slice(0, -1)
          .split('(')[1]
          .split(',')
          .map((val) => val.trim());

        return {
          r: parseInt(values[0], 10),
          g: parseInt(values[1], 10),
          b: parseInt(values[2], 10),
          a: parseFloat(values[3]) || 1
        };
      };

      colorStringToValue = (color) => {
        if (!color) return '';
        if (color.indexOf('#') === 0) return color;
        return this.rgbStringToObject(color);
      };

      handleClick = (ev) => {
        ev.stopPropagation();
        this.setState({ pickerVisible: true });
        document.addEventListener('click', this.handleClickOutside);
      };

      handleClickOutside = (ev) => {
        if (this.pickerElement && this.pickerElement.contains(ev.target))
          return;
        document.removeEventListener('click', this.handleClickOutside);
        this.setState({ pickerVisible: false });
      };

      handleClear = (ev) => {
        ev.stopPropagation();
        this.props.fieldApi.setValue(null);
        if (this.props.onChange) this.props.onChange(null);
      };

      handleChange = (color) => {
        const value =
          color.rgb.a === 1 ? color.hex : this.rgbObjectToString(color.rgb);

        this.props.fieldApi.setValue(value);
        if (this.props.onChange) this.props.onChange(value);
      };

      render() {
        const {
          fieldState: { error, value },
          style,
          theme
        } = this.props;

        const { pickerVisible } = this.state;

        return (
          <div className="colorpicker" style={style}>
            <div className="input" onClick={this.handleClick}>
              <TextInput
                error={error}
                placeholder={'Choose color'}
                readOnly={true}
                style={{ padding: '7px 10px 7px 32px' }}
                value={value || ''}
              />
              <div
                className="color"
                style={
                  value
                    ? {
                        backgroundColor: value,
                        borderColor: theme.lightGreyDark
                      }
                    : {
                        backgroundColor: 'transparent'
                      }
                }
              >
                {!value ? (
                  <Icon icon="palette" style={{ color: '#ccc' }} />
                ) : null}
              </div>

              {value ? (
                <button
                  className="clear"
                  onClick={this.handleClear}
                  type="button"
                >
                  <Icon icon="times" />
                </button>
              ) : null}
            </div>

            {pickerVisible ? (
              <div
                className="picker"
                ref={(el) => {
                  this.pickerElement = el;
                }}
              >
                <ChromePicker
                  color={this.colorStringToValue(value)}
                  onChangeComplete={this.handleChange}
                />
              </div>
            ) : null}

            {error ? <div className="error-message">{error}</div> : null}

            <style jsx>{`
              .colorpicker {
                display: inline-block;
              }
              .input {
                cursor: pointer;
                position: relative;
              }
              .color {
                border: 1px solid transparent;
                border-radius: 50%;
                color: ${theme.textColorLighter};
                display: inline-block;
                font-size: 1.3rem;
                margin-right: 7px;
                padding: 0;
                position: absolute;
                text-align: center;
                top: 8px;
                left: 8px;
                width: 19px;
                height: 19px;
              }
              .clear {
                background: transparent;
                border: 0;
                color: ${theme.textColorLighter};
                cursor: pointer;
                font-size: 1.5rem;
                padding: 0;
                position: absolute;
                transition: color 0.3s;
                top: 6px;
                right: 6px;
                width: 23px;
                height: 23px;
              }
              .clear:focus,
              .clear:hover {
                color: ${theme.textColor};
              }
              .picker {
                position: absolute;
                z-index: 2;
              }
              .error-message {
                color: ${theme.dangerColor};
                font-size: 1.3rem;
                padding: 3px;
              }
            `}</style>
          </div>
        );
      }
    }
  )
);

export default ColorPicker;
